// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"511d5b5332d0cce48f4d","453":"20aab1d8ab00a3fcb50d","522":"5cce977d401fb7fcf772"}[chunkId] + ".js";
};